import useSite from '../hooks/useSite';

export const Disclaimer = () => {
  const [site] = useSite();

  if (!site?.disclaimer) {
    return <></>;
  }

  return (
    <div className="p-2 text-left text-xs text-gray-500">
      <p>{site?.disclaimer}</p>
    </div>
  );
};
